import {
  CheckAgreementRequest,
  CheckAgreementResponse
} from "../../../types/gqlTypes/graphql"
import { executeQuerySideload } from "../../generic-services/helpers/studyPlan"
import { CHECK_AGREEMENT } from "./agreementQueries"

export async function checkAgreement(
  data: CheckAgreementRequest
): Promise<CheckAgreementResponse> {
  // Identical variables must not share an in-flight result across accounts.
  const response = await executeQuerySideload(CHECK_AGREEMENT, { data }, {
    apiName: "STUDY_PLAN",
    queryDeduplication: false
  })
  return response.agreements.checkAgreement
}
